import { apiOrigin } from "../constants/api";
import axios from "axios";
import { showErrorSnackbar } from "./feedback";
import Cookies from "js-cookie";

const DISABLE_ERROR_SNACKBAR =
  process.env.REACT_APP_DISABLE_ERROR_SNACKBAR?.toString().toLowerCase() ==
  "true";

export const getStudentDashboardLink = () => {
  return `${apiOrigin}/student`;
};

const api = axios.create({
  baseURL: apiOrigin,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    if (!DISABLE_ERROR_SNACKBAR) {
      showErrorSnackbar("We experienced an error processing your request.");
    }
    return Promise.reject(error);
  }
);

api.interceptors.response.use(undefined, (error) => {
  if (!DISABLE_ERROR_SNACKBAR) {
    showErrorSnackbar("We experienced an error processing your request.");
  }
  return Promise.reject(error);
});

export function serializeSearchParams(params) {
  const newParams = {};
  for (let [key, val] of Object.entries(params)) {
    if (Array.isArray(val)) {
      newParams[key] = val.toString();
    } else if (val && typeof val == "object") {
      newParams[key] = JSON.stringify(val);
    } else {
      newParams[key] = val;
    }
  }
  return newParams;
}
export default api;
